import * as React from 'react';
import { setOriginalNode } from 'typescript';
export type UserProps = {
  email: String;
  password: String;
  name: String;

}

export type UserContextType = {
  currentUser?: UserProps;
  
  setCurrentUser?: (user: UserProps) => void;
  checkLogin: () => void;
  setAuthLoading: (isLoading: boolean) => void;
  authLoading: boolean;
  handleLogout: () => void;
  //testData: String
}

type ProviderProps = {
  children: React.ReactNode;
}


 //initial state of user
export const CurrentUserContext = React.createContext<UserContextType |any>(null);

export const CurrentUserProvider: React.FC<ProviderProps> = ({ children })=>{
  const [currentUser, setCurrentUser] = React.useState<UserProps | any>();
  const [authLoading, setAuthLoading] = React.useState(false);
  
  React.useEffect(() => {
    checkLogin();
  }, [])
  
  const checkLogin = async() => {
    let token = localStorage.getItem("token");
    if (token) {
      token = token!.replace(/(^"|"$)/g, '')
      console.log(token);
    }
   
    
    setAuthLoading(true);

    if (token) {
      await fetch(`https://api-j06q.onrender.com/api/user/profile/${token}`)
        .then((response) => {
          return response.json()
        }).then((data: {
          user: UserProps 
}) => {
          setAuthLoading(false)
          if (data) {
            setCurrentUser(data)
            setAuthLoading(false)
            
          }
      })
    } else {
      setAuthLoading(false)
      setCurrentUser(null)
    }
    
  }

  const handleLogout = () => { 
    localStorage.clear();
    setCurrentUser(null);
  } 
  const stateValues = {
    currentUser,
    setCurrentUser,
    checkLogin,
    setAuthLoading,
    authLoading,
    handleLogout,
  }

  return <CurrentUserContext.Provider value={stateValues}>{children}</CurrentUserContext.Provider>
}
